/**
 * Autoguardado del trabajo en curso.
 *
 * Se guarda con retardo para no serializar el proyecto entero en cada frame de
 * un arrastre. Es una red de seguridad ante un cierre accidental de la pestaña,
 * no un sistema de versiones: cada guardado pisa al anterior.
 */

import { AUTOSAVE_DELAY_MS, STORAGE_KEYS } from '../config.js';

export class Autosave {
  /** @param {() => object} serialize Devuelve el proyecto en su forma guardable. */
  constructor(serialize, delay = AUTOSAVE_DELAY_MS) {
    this.serialize = serialize;
    this.delay = delay;
    this.timer = null;
    this.enabled = true;
  }

  schedule() {
    if (!this.enabled) return;
    clearTimeout(this.timer);
    this.timer = setTimeout(() => this.flush(), this.delay);
  }

  flush() {
    try {
      localStorage.setItem(STORAGE_KEYS.autosave, JSON.stringify(this.serialize()));
    } catch {
      // Almacenamiento lleno o denegado: perder el autoguardado no puede tumbar
      // la sesión de trabajo en curso.
    }
  }

  restore() {
    try {
      const raw = localStorage.getItem(STORAGE_KEYS.autosave);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }

  clear() {
    clearTimeout(this.timer);
    try {
      localStorage.removeItem(STORAGE_KEYS.autosave);
    } catch {
      /* nada que limpiar */
    }
  }

  /** Suspende el autoguardado mientras se carga un proyecto, para no pisarlo a medio armar. */
  suspend() {
    this.enabled = false;
    clearTimeout(this.timer);
  }

  resume() {
    this.enabled = true;
  }
}
